module.exports = __webpack_public_path__ + "static/media/bg_06.b8c4000d.png";